import { connect } from 'react-redux'
import StatusNotInWonde from './status-not-in-wonde'
import { connectToWonde } from '../../../../../../../stores/school-data/school-data.actions'
import { getSchoolData } from '../../../../../../../stores/school-data/school-data.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  return {
    id: school.id,
    statusColor: school.wonde.color
  }
}

const mapDispatchToProps = dispatch => ({
  onConnect: schoolId => dispatch(connectToWonde(schoolId)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusNotInWonde)
